// DS1.7.9
import React from 'react';
import classname from 'classnames';
import s from './DailyDeviationIndicator.scss';
var DailyDeviationIndicator = function (_a) {
    var size = _a.size, withHoverEffect = _a.withHoverEffect, className = _a.className;
    return (React.createElement("div", { className: classname(s['root'], s[size], withHoverEffect && s['hoverable'], className) }));
};
DailyDeviationIndicator.displayName = 'DailyDeviationIndicator';
export default DailyDeviationIndicator;
//# sourceMappingURL=DailyDeviationIndicator.js.map